(function () {
  function init(root) {
    if (!root || root.dataset.sunnierTabsInit === "true") return;
    root.dataset.sunnierTabsInit = "true";

    const tabs = Array.from(root.querySelectorAll("[data-sunnier-tab]"));
    const panels = Array.from(root.querySelectorAll("[data-sunnier-tab-panel]"));
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach((tab) => {
        const active = tab.dataset.sunnierTab === id;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.sunnierTabPanel === id;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activate(tab.dataset.sunnierTab));
      tab.addEventListener("keydown", (event) => {
        const index = tabs.indexOf(tab);
        if (event.key === "ArrowRight") {
          event.preventDefault();
          const next = tabs[(index + 1) % tabs.length];
          next.focus();
          activate(next.dataset.sunnierTab);
        } else if (event.key === "ArrowLeft") {
          event.preventDefault();
          const prev = tabs[(index - 1 + tabs.length) % tabs.length];
          prev.focus();
          activate(prev.dataset.sunnierTab);
        }
      });
    });

    const initial =
      tabs.find((tab) => tab.classList.contains("is-active")) || tabs[0];
    if (initial) activate(initial.dataset.sunnierTab);
  }

  function boot() {
    document.querySelectorAll("[data-sunnier-tabs]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
